import React from 'react';
import { Col, Row } from 'components';
import { ShippingAddresses } from 'feature/clientTabs/shipping/shippingAddresses';
import { SpecialRates } from './specialRates';
import { HasAccess } from 'components/common/accessControl';
import { PERMISSIONS } from 'constants/permissions';

export const Shipping = React.memo(() => {
  return (
    <Row className={'gap-40'}>
      <Col flex={'1'}>
        <HasAccess role={PERMISSIONS.clients.shipping_address.read}>
          <ShippingAddresses />
        </HasAccess>
      </Col>
      <Col flex={'1'}>
        <HasAccess role={PERMISSIONS.clients.special_shipping_rate.read}>
          <SpecialRates />
        </HasAccess>
      </Col>
    </Row>
  );
});
